export default __webpack_public_path__ + "static/media/headingbackground.4a163e0f.jpg";